g<template>
  <div>
    <div class="layout-ceiling" style="position: fixed;z-index: 999;width: 100%;top: 0;left: 0;">
      <div class="btn">
        <i-button type="primary" @click="exit" style="float: right">退出</i-button>
      </div>
    </div>
    <div class="title">
      <h1>核对答案 </h1>
      <p>剑雅13-Test 2</p>
    </div>
    <Card style="width: 1200px;margin: 20px auto;">
        <div class="card-top">
          <div class="card-top-left" :class="{isselect:isReading}" @click="changeMod(true)">
            <p>Listening</p></div>
          <div class="card-top-right" :class="{isselect:!isReading}" @click="changeMod(false)">
            <p>Reading</p></div>
        </div>
        <div class="card-content">
          <div class="content-left" style="border-right: 1px solid #f2f2f2;">
            <h1>我的答案</h1>
            <ul>
              <li v-for="(item,index) in this.$route.params.answer.hearing" :key="index" v-if="isReading">{{index+1}}. {{item}}</li>
              <li v-for="(item,index) in this.$route.params.answer.reading" :key="index" v-if="!isReading">{{index+1}}. {{item}}</li>
            </ul>
          </div>
          <div class="content-right">
            <h1 style="color: #ff9900">正确答案</h1>
            <ul>
              <li v-for="(item,index) in sureListenAnswer" :key="index" v-if="!isReading">{{item.serial}}. {{item.answer}}</li>
              <li v-for="(item,index) in sureReadingAnswer" :key="index" v-if="isReading">{{item.serial}}. {{item.answer}}</li>
            </ul>
          </div>
        </div>
    </Card>
  </div>
</template>

<script>
  import ajax from './../../api/ajax'
  export default {
    name: "Answer",
    data(){
      return{
        data:[],
        url:"https://winielts.com",
        sureListenAnswer:[],
        sureReadingAnswer:[],
        isReading:true,
        myAnswer:[],
        // jia:['1231','asdsad','asdsad',0,2,3,[1,2],[3,4]]
      }
    },
    mounted(){
      this.getAnswer()
      console.log(this.$route.params.answer);
    },
    methods:{
      exit(){
        this.$Modal.confirm({
          title: '返回',
          content: '<p>即将返回首页，是否确认？</p>',
          okText: '确认',
          cancelText: '取消',
          onOk: () => {
            window.onbeforeunload = null
            this.$router.push({name: 'home'})
          },
        });
      },
      async getAnswer(){
        const data = await ajax(this.url + '/api/ieltsCategory/getCamAnswer',{camNum:this.$route.params.camNum,topicType:3,testNum:this.$route.params.testNum})
        const data2 = await ajax(this.url +'/api/ieltsCategory/getCamAnswer',{camNum:this.$route.params.camNum,topicType:1,testNum:this.$route.params.testNum})
        let answerList = []
        data.data.forEach((item,index)=>{
          item.sectionAnswerViews.forEach((item1,index)=>{
              answerList.push(item1)
          })
        })
        let answerList2 = []
        data2.data.forEach((item,index)=>{
          item.sectionAnswerViews.forEach((item1,index)=>{
            answerList2.push(item1)
          })
        })
        this.sureListenAnswer = answerList
        this.sureReadingAnswer = answerList2
      },
      changeMod(flag){
        this.isReading =  flag
      }
    }
  }
</script>
<style>
  /*.ivu-card-body{*/
    /*padding-top: 0;*/
  /*}*/
</style>
<style scoped lang="stylus">
  .btn
    width 96%
  .card-content
    display: flex
    justify-content: center
    margin-top: 10px
    margin-bottom 10px
    div
      width 50%
      h1
        text-align: center
        font-size:20px
        color #333
      ul
        margin 0 auto
        margin-top 10px
        width 80%
        display: flex
        flex-wrap wrap
        justify-content: center
        li
          font-size:14px
          color #333
          padding-top 10px
          width 200px
  .card-top
    display: flex
    justify-content: center
    align-items: center
    margin-top: -16px
    div
      height:60px
      width: 170px
      font-size: 16px;
      display: flex
      /*align-items: center*/
      justify-content: center
      color #333
      cursor pointer
      line-height 54px
    .isselect
      background url("/static/img/block_section.png")
      color #fff
  .title
    margin-top 86px
    width 100%
    text-align: center
    h1
      color: #333
      font-size:20px
    p
      color: #808080
      font-size: 16px;
      margin-top 6px

  .layout-ceiling
    height 57px
    background: #464c5b;
    padding: 10px 0;
    overflow: hidden;
    display: flex
    align-items: center
    justify-content: space-between
    color #9ba7b5
    font-size 14px
    .layout-time
      display: flex
      ///*margin-right: 20px*/
      span
        font-size:18px
        padding: 0 4px
        i
          font-size:16px
          font-style normal

  .question-item
    padding 10px 10px
  .checkbox
    display: flex
    flex-direction: column
    .ivu-checkbox-wrapper
      padding:10px 0
  .ivu-row:last-child
    margin-bottom  67px
</style>



// WEBPACK FOOTER //
// src/pages/Answer/Answer.vue